import { DialogContentComponent } from "../dialog-instance/types/DialogContentComponent";
import { DialogContentComponentResolver } from "../dialog-instance/types/DialogContentComponentResolver";

export function withStaticDialogComponent<TModel>(component: DialogContentComponent<TModel>): DialogContentComponentResolver<TModel> {
    return () => {
        return Promise.resolve(component);
    };
}
